const Data =[
  {
    id:1,
    name:'Child Support',
    picture:'https://iili.io/2XMj07.png'
  },
  {
    id:2,
    name:'Collect school supplies',
    picture:'https://iili.io/2XMDzv.png'
  },
  {
    id:3,
    name:'Teach people  how to register to vote',
    picture:'https://iili.io/2XMyqN.png'
  },
  {
    id:4,
    name:'Collected stuffed Animals',
    picture:'https://iili.io/2XMmsp.png'
  },
  {
    id:5,
    name:'Babysit during PTA meetings',
    picture:'https://iili.io/2XMhfS.png'
  },
  {
    id:6,
    name:'Faster a Shelter Animals',
    picture:'https://iili.io/2XMOJe.png'
  },
  {
    id:7,
    name:'Give IT help to local adults',
    picture:'https://iili.io/2XM60P.png'
  },
  {
    id:8,
    name:'Clean up your Local park',
    picture:'https://iili.io/2XMkOb.png'
  },
  {
    id:9,
    name:'Give Free music lesson',
    picture:'https://iili.io/2XMsdF.png'
  },
  {
    id:10,
    name:'Give a seminar on driving safety',
    picture:'https://iili.io/2XMSzx.png'
  },
  {
    id:11,
    name:'Organize books at the library ',
    picture:'https://iili.io/2XMPg1.png'
  },
  {
    id:12,
    name:'Build birdhouse for your neighbors',
    picture:'https://iili.io/2XMwg9.png'
  },
  {
    id:13,
    name:'Host a study group',
    picture:'https://iili.io/2XMbXR.png'
  },
  {
    id:14,
    name:'New books for children',
    picture:'https://iili.io/2XML5g.png'
  },
  {
    id:15,
    name:'Good education',
    picture:'https://iili.io/2XM4qB.png'
  },
  {
    id:16,
    name:'Refuge shelter',
    picture:'https://iili.io/2XMQea.png'
  },
  {
    id:17,
    name:'Food Charity',
    picture:'https://iili.io/2XMgsV.png'
  },
  {
    id:18,
    name:'Host a clothing swap',
    picture:'https://iili.io/2XMvbj.png'
  },
  {
    id:19,
    name:'Host a river clean-up',
    picture:'https://iili.io/2XMZmJ.png'
  },
  {
    id:20,
    name:'Clean water for children',
    picture:'https://iili.io/2XMe5u.png'
  },
]
export default Data;